











import { computed, defineComponent, PropType } from 'vue-demi';
import { FitButton } from '@tencent/wphk-ui';
import { MallInfo } from '../type';
import { i18n } from '../../../i18n';
import { windowHelper } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'MallContentInfo',
  components: {
    FitButton,
  },
  props: {
    data: {
      type: Object as PropType<MallInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const mallInfo = computed(() => {
      const { id, name, desc, addr } = props.data;
      return { id, name, desc, addr };
    });

    function handleClick() {
      const url = `//prom.wechatpay.com.hk/merchant-channel/index.shtml?ADTAG=mall&spId=${encodeURIComponent(mallInfo.value.id)}`;
      windowHelper.redirect(url);
    }

    return {
      i18n,
      mallInfo,
      handleClick,
    };
  },
});
